import { useFormikContext } from "formik";
import { FC, useContext, useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import ThongTinPhieu from "./ThongTinPhieu";
import ThongTinXuatThuoc from "./ThongTinXuatThuoc";
import WfButton from "../../../../workflows/components/WfButton";
import {TYPE_WH, WAREHOUSE_ID, WF_TRACKER} from "../../../../utils/Constant";
import FormThemVatTu from "./FormThemVatTu";
import { PhieuXuat } from "../../../../phan-he-xuat-kho/models/XuatKhoModel";
import { WMS_STATUS } from "../../../../phan-he-nhap-kho/constants/constansNhapKho";
import {HOAN_TRA_DVKT, trackerCode} from "../../../Constant";

type Props = {
  isReload?: boolean;
  onHide: () => void;
  type?: any;
  warehouseExportType?: any;
  warehouseId: number;
  listJsonGeneratePhieuXuat?: any;
};

const FormThemMoi: FC<Props> = (props) => {
  const { warehouseExportType, type, listJsonGeneratePhieuXuat, warehouseId } = props;
  const { handleSubmit, values } = useFormikContext<PhieuXuat>();
  const [statusPhieu, setStatusPhieu] = useState<any>(false);
  const [isView, setIsView] = useState(false);

  const renderButton = () => {
      return <>
        <WfButton
          tracker={warehouseExportType?.code === HOAN_TRA_DVKT.DA_TONG_HOP.code ? HOAN_TRA_DVKT.DA_TONG_HOP.tracker : trackerCode.issue_orders_export_summary}
          objectId={values?.phieuXuatKhoAdd?.id}
          // type={warehouseExportType?.code === HOAN_TRA_DVKT.code ? TYPE_WH.IMPORT : TYPE_WH.EXPORT}
          additionalFunc={(data) =>
            setStatusPhieu({
              status: data?.currCode
            })
          }
        />
      </>
  };
  useEffect(() => {
    const isView =
      (values.phieuXuatKhoAdd?.statusId && values.phieuXuatKhoAdd?.statusId === WMS_STATUS.warehouse_approved)
      || statusPhieu.status === WMS_STATUS.warehouse_approved;

    setIsView(isView);
  }, [statusPhieu, values.phieuXuatKhoAdd?.statusId]);

  return (
    <div className="bg-gray">
      <Form className="receive" >
        <div className="spaces width-100 ">
         
            <>
              <ThongTinPhieu
                modelID="phieuXuatKhoAdd"
                listJsonGeneratePhieuXuat={listJsonGeneratePhieuXuat}
                isView={isView}
              />
              {/* <FormThemVatTu
                isView={isView}
                statusPhieu={statusPhieu}
                warehouseExportType={warehouseExportType}
                inventoryId={values.phieuXuatKhoAdd?.inventoryId}
                id={values.phieuXuatKhoAdd?.id}
                warehouseId={warehouseId}
                generalValues={values}
              /> */}
            </>
          <ThongTinXuatThuoc isView={isView} statusPhieu={statusPhieu} id={values.phieuXuatKhoAdd?.id} warehouseExportType={warehouseExportType} warehouseId={warehouseId} />

        </div>
        <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-10">
          {renderButton()}
        </div>
      </Form>
    </div>
  );
};
export default FormThemMoi;
